let utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'referral-edit',
  created () {
    this.search()
  },
  data () {
    return {
      searchCallbackFlag: false,
      shopName: '',
      workStyle: '',
      referralData: {
        is_publish: '',
        referral_id: '',
        job_category: '',
        salary: '',
        welfare: '',
        work_detail: '',
        work_hours: ''
      },
      canEditFlag: false
    }
  },
  computed: {
  },
  components: {
    AppHeader
  },
  methods: {
    search: function () {
      let data = {
        id: this.$route.params.referral_id
      }
      this.$store
        .dispatch('GET_REFERRAL_DETAIL', { data: data })
        .then(res => {
          this.shopName = res.data.attributes['shop-name']
          this.workStyle = res.data.attributes['work-style']
          this.referralData.is_publish = res.data.attributes['is-publish']
          this.referralData.referral_id = res.data.id
          this.referralData.salary = res.data.attributes['salary']
          this.referralData.job_category = res.data.attributes['job-category']
          this.referralData.welfare = res.data.attributes['welfare']
          this.referralData.work_detail = res.data.attributes['work-detail']
          this.referralData.work_hours = res.data.attributes['work-hours']
          this.searchCallbackFlag = true
        })
        .catch(err => console.log(err))
    },
    isChecked: function (isPublish) {
      return isPublish === 1 ? true : false
    },
    changePublish: function () {
      if (window.confirm('公開状態を変更しますか？\n※即時変更されます')) {
        let data = {
          referral_id: this.referralData.referral_id,
          is_publish: this.referralData.is_publish === 0 ? 1 : 0
        }
        this.$store.dispatch('CHANGE_PUBLISH', { data: data })
        .then(res => {
          this.referralData.is_publish = this.referralData.is_publish === 0 ? 1 : 0
          this.$forceUpdate()
        })
        .catch(err => console.log(err))
      } else {
        this.$forceUpdate()
      }
    },
    wordCounter: function (word) {
      return word.length
    },
    onClickSave: function () {
      let self = this
      let callback = function () {
        self.canEditFlag = false
        window.alert('更新しました。')
        self.search()
      }
      this.$store.dispatch('REFERRAL_UPDATE', { data: this.referralData, callback: callback })
    },
    onClickCancel: function () {
      this.$router.push('/referral')
    },
    changeCanEdit: function () {
      this.canEditFlag === true ? this.canEditFlag = false : this.canEditFlag = true
      if (!this.canEditFlag) {
        this.search()
      }
    },
    canEdit: function () {
      return this.canEditFlag ? false:true
    },
    required: function (checkedValue) {
      return utils.isBlank(checkedValue)
    },
    notInput: function () {
      if (!this.referralData.salary ||
        !this.referralData.work_hours ||
        !this.referralData.work_detail ||
        !this.referralData.welfare ||
        !this.referralData.job_category) {
        return true
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/scripts/referral-edit.js